/* DK · Sichtbarkeitssystem landing — interakcije (bez WebGL-a) */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- 1) Reveal-on-scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll("[data-reveal]");
    if (!("IntersectionObserver" in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2) AGB gating ---------- */
  function initAgb() {
    var check = document.getElementById("vk-agb-check");
    var btn = document.getElementById("vk-submit");
    var hint = document.getElementById("vk-agb-hint");
    if (!check || !btn) return;
    function sync() {
      btn.disabled = !check.checked;
      if (hint) {
        hint.textContent = check.checked ? "Du wirst sicher zur Kasse weitergeleitet." : "Bitte bestätige die AGB, um fortzufahren.";
        hint.classList.toggle("is-ok", check.checked);
      }
    }
    check.addEventListener("change", sync);
    sync();
  }

  /* ---------- 4) Pinned scroll-scrub hero ---------- */
  function initHeroScroll() {
    var track = document.getElementById("vk-hero-track");
    if (!track) return;
    var hero = track.querySelector(".vk-hero");
    var box = track.querySelector(".vk-box");
    var video = document.getElementById("vk-hero-video");
    if (!hero || !box) return;

    // Pinned scroll-scrub isključen na zahtev — video ostaje normalan autoplay/loop.
    var activate = false;
    if (!activate) {
      if (reduceMotion && video) { try { video.pause(); } catch (e) {} }
      return;
    }

    track.classList.add("is-pinned");

    var dur = 0;
    if (video) {
      video.loop = false;
      video.removeAttribute("autoplay");
      try { video.pause(); } catch (e) {}
      if (video.readyState >= 1 && isFinite(video.duration)) dur = video.duration;
      video.addEventListener("loadedmetadata", function () { dur = video.duration || 0; });
    }

    var others = Array.prototype.slice.call(hero.querySelectorAll(".vk-hero__inner > *"))
      .filter(function (el) { return !el.classList.contains("vk-box"); });

    var coverScale = 1.5;
    var baseCenterY = 0;
    function recompute() {
      var prev = box.style.transform;
      box.style.transform = "none";
      var r = box.getBoundingClientRect();
      box.style.transform = prev;
      if (r.width && r.height) {
        var vh = window.innerHeight;
        var margin = 16;
        var cy = r.top + r.height / 2;   // centar boxa (sticky → stabilno tokom pina)
        var halfH = r.height / 2;
        var widthScale = Math.min(1140, window.innerWidth * 0.92) / r.width;
        var bottomFit = (vh - margin - cy) / halfH;  // da dno ostane u hero okviru
        var topFit = (cy - margin) / halfH;          // da vrh ostane u hero okviru
        coverScale = Math.max(1, Math.min(widthScale, bottomFit, topFit)) * 1.155;
      }
    }

    var ticking = false;
    function update() {
      ticking = false;
      var rect = track.getBoundingClientRect();
      var total = track.offsetHeight - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;

      // ostaje u mestu, samo raste iz centra
      box.style.transform = "scale(" + (1 + p * (coverScale - 1)).toFixed(4) + ")";

      if (video && dur) {
        var t = p * dur;
        if (isFinite(t)) { try { video.currentTime = t; } catch (e) {} }
      }
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }

    recompute();
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () { recompute(); update(); });
  }

  /* Safari/iOS: VP9-alpha webm se ne renderuje providno → koristi HEVC-alpha mp4 */
  function initVideoSource() {
    var v = document.getElementById("vk-hero-video");
    if (!v) return;
    var box = v.closest && v.closest(".vk-box");
    function fallback() { if (box) box.classList.add("is-video-fallback"); }
    function showVideo() { if (box) box.classList.remove("is-video-fallback"); }
    function setRate() { try { v.playbackRate = 1.2; } catch (e) {} }
    v.addEventListener("error", fallback);
    v.addEventListener("canplay", showVideo);
    v.addEventListener("loadedmetadata", setRate);
    v.addEventListener("play", setRate);
    setRate();
    var ua = navigator.userAgent;
    var isSafari = /safari/i.test(ua) && !/chrome|chromium|crios|android|edg|fxios|samsungbrowser/i.test(ua);
    var hevc = v.getAttribute("data-hevc");
    if (isSafari && hevc) {
      v.src = hevc;
      v.load();
      var p = v.play && v.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  /* ---------- Bonus timeline: levo kartice menjaju desnu sliku ---------- */
  function initTimeline() {
    var rail = document.querySelector(".vk-timeline__rail");
    if (!rail) return;
    var steps = rail.querySelectorAll(".vk-step");
    var medias = document.querySelectorAll(".vk-timeline__stage .vk-stage-media");
    function setActive(i) {
      for (var k = 0; k < steps.length; k++) steps[k].classList.toggle("is-active", k === i);
      for (var m = 0; m < medias.length; m++) medias[m].classList.toggle("is-active", m === i);
    }
    if (!("IntersectionObserver" in window)) { setActive(0); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var idx = parseInt(e.target.getAttribute("data-step"), 10) || 0;
          setActive(idx);
        }
      });
    }, { rootMargin: "-45% 0px -45% 0px", threshold: 0 });
    for (var s = 0; s < steps.length; s++) io.observe(steps[s]);
    setActive(0);
  }

  /* ---------- Quantity stepper ---------- */
  function initQty() {
    var wraps = document.querySelectorAll(".vk-qty");
    for (var w = 0; w < wraps.length; w++) {
      (function (wrap) {
        var input = wrap.querySelector(".vk-qty__input");
        var btns = wrap.querySelectorAll(".vk-qty__btn");
        for (var i = 0; i < btns.length; i++) {
          btns[i].addEventListener("click", function (ev) {
            var v = parseInt(input.value, 10) || 1;
            v += ev.currentTarget.getAttribute("data-act") === "inc" ? 1 : -1;
            if (v < 1) v = 1;
            if (v > 99) v = 99;
            input.value = v;
          });
        }
      })(wraps[w]);
    }
  }

  /* ---------- Countdown top bar ---------- */
  function initCountdown() {
    var bar = document.getElementById("vk-topbar");
    var out = document.getElementById("vk-countdown");
    if (!bar || !out) return;
    var deadline = new Date(bar.getAttribute("data-deadline")).getTime();
    if (isNaN(deadline)) return;
    function pad(n) { return (n < 10 ? "0" : "") + n; }
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) { out.textContent = "abgelaufen"; bar.classList.add("is-ended"); return; }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      out.textContent = (d > 0 ? d + "T " : "") + pad(h) + "Std " + pad(m) + "Min " + pad(s) + "Sek";
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---------- Preis-Treppe (Heute = echter Shopify-Preis, Morgen = +Schritt) ---------- */
  function initPriceLadder() {
    var box = document.querySelector(".vk-ladder");
    if (!box) return;
    function euros(n) { return Math.round(n).toLocaleString("de-DE") + " €"; }
    function setVal(sel, txt) { var e = box.querySelector(sel); if (e) e.textContent = txt; }

    var todayC = parseInt(box.getAttribute("data-today"), 10);
    var webinar = parseInt(box.getAttribute("data-webinar"), 10) || 0;
    var inc = parseInt(box.getAttribute("data-increase"), 10) || 0;
    var full = parseInt(box.getAttribute("data-full"), 10) || 0;
    var today = (isFinite(todayC) && todayC > 0) ? todayC / 100 : webinar;
    var capped = full > 0 ? Math.min(today + inc, full) : today + inc;
    var tomorrow = inc > 0 ? capped : today;

    setVal(".vk-ladder__val--webinar", euros(webinar));
    setVal(".vk-ladder__val--today", euros(today));
    setVal(".vk-ladder__val--tomorrow", euros(tomorrow));
    setVal(".vk-ladder__val--full", euros(full));

    // Schritt-Betrag überall (Hero-Hinweis + Treppe)
    var incEls = document.querySelectorAll(".vk-inc");
    for (var i = 0; i < incEls.length; i++) incEls[i].textContent = euros(inc);

    // Schon (fast) am Vollpreis → "+Schritt" abschwächen
    if (full > 0 && today + inc >= full) {
      var up = box.querySelector(".vk-ladder__tag--up");
      if (up) up.textContent = "Endpreis";
    }
    if (full > 0 && today >= full) {
      box.classList.add("is-maxed");
    }

    // Countdown bis Mitternacht (nächste Erhöhung)
    var out = document.getElementById("vk-ladder-countdown");
    if (!out) return;
    function pad(n) { return (n < 10 ? "0" : "") + n; }
    function tick() {
      var now = new Date();
      var next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var s = Math.max(0, Math.floor((next - now) / 1000));
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      out.textContent = pad(h) + ":" + pad(m) + ":" + pad(s);
      setTimeout(tick, 1000);
    }
    tick();
  }

  function boot() {
    initVideoSource();
    initCountdown();
    try { initPriceLadder(); } catch (e) {}
    initReveal();
    initAgb();
    try { initTimeline(); } catch (e) {}
    try { initQty(); } catch (e) {}
    try { initHeroScroll(); } catch (e) { /* fallback: normalan hero */ }
  }

  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
})();
